import { useState, useEffect, useCallback, useRef } from "react";
import { scoutAgentService } from "../../services/scoutAgentService";

// "My recommendations" (design 1n/1o). The list carries the single agent-visible
// signal — the derived `on_radar` bool — and NOTHING else (no pending, no
// dismissed): Invariant 2. The UI turns that bool into either the green "On the
// radar" pill or an empty status cell; there is no other status string anywhere.
export const useMyRecommendations = () => {
  const [recommendations, setRecommendations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [pagination, setPagination] = useState({ count: 0, next: null, previous: null, currentPage: 1 });
  const abortRef = useRef(null);

  const fetchRecommendations = useCallback(async (page = 1) => {
    setLoading(true);
    setError(null);
    if (abortRef.current) abortRef.current.abort();
    const controller = new AbortController();
    abortRef.current = controller;
    const params = new URLSearchParams();
    params.append("page", page);
    try {
      const res = await scoutAgentService.getMyRecommendations(params, controller.signal);
      if (res.success) {
        setRecommendations(res.data);
        setPagination(res.pagination);
      } else {
        setError(res.error || "Failed to load your recommendations.");
      }
    } catch (err) {
      if (err?.name === "CanceledError" || err?.name === "AbortError") return;
      setError("Failed to load your recommendations. Please try again.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchRecommendations(1);
  }, [fetchRecommendations]);

  return { recommendations, loading, error, pagination, fetchRecommendations };
};

export default useMyRecommendations;
